import { render } from "./CustomerSNSAuth.vue?vue&type=template&id=3afd9c5b"
import script from "./CustomerSNSAuth.vue?vue&type=script&lang=js"
export * from "./CustomerSNSAuth.vue?vue&type=script&lang=js"

import exportComponent from "/home/ec2-user/environment/links-frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__